<script setup lang="ts">
  import { computed } from 'vue';
  import Eye from '@/shared/assets/icons/EyeGray.svg';
  import PencilGray from '@/shared/assets/icons/PencilGray.svg';
  import TextBoxIcon from '@/shared/assets/icons/TextBoxIcon.svg';
  import Trash from '@/shared/assets/icons/TrashIcon.svg';
  import { IconImage, Tooltip } from '@/shared/ui';
  import type { RecordAction } from '../model/models.types';

  const ACTIONS: { icon: string; label: string; key: RecordAction }[] = [
    { icon: Eye, label: 'Visualizar', key: 'view' },
    { icon: PencilGray, label: 'Editar', key: 'edit' },
    { icon: TextBoxIcon, label: 'Renomear', key: 'rename' },
    { icon: Trash, label: 'Deletar', key: 'delete' },
  ];

  const props = withDefaults(
    defineProps<{
      hiddenActions?: readonly RecordAction[];
    }>(),
    { hiddenActions: () => [] }
  );

  const emit = defineEmits<{
    action: [key: RecordAction];
  }>();

  const visibleActions = computed(() =>
    ACTIONS.filter((action) => !props.hiddenActions.includes(action.key))
  );
</script>

<template>
  <td class="px-6 py-4.5 text-sm text-gray-07 text-left">
    <div class="flex gap-2 text-gray-xx-02">
      <Tooltip
        v-for="action in visibleActions"
        :key="action.label"
        :content="action.label"
        placement="top"
        class="flex items-center"
      >
        <button
          type="button"
          @click="emit('action', action.key)"
        >
          <IconImage
            :src="action.icon"
            :alt="action.label"
          />
        </button>
      </Tooltip>
    </div>
  </td>
</template>
